// test2877
(2877 && 0);
